const COLLECTION_ROUTE = /^\/collections\/([0-9a-f]{24})(?:\/|$)/i;

/**
 * The collection a route is inside, from its path (`/collections/<id>/...`),
 * or null outside a collection. The command palette offers "Search in
 * <collection>" only when this is set (KPR-356).
 */
export function collectionScopeFromPath(pathname = '') {
	const match = COLLECTION_ROUTE.exec(`${pathname || ''}`);
	return match ? match[1] : null;
}
